var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
    !_vm.isAdd
      ? _c(
          "div",
          [
            _c(
              "el-card",
              { attrs: { header: "投保须知" } },
              [
                _c(
                  "el-container",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoadingPdf,
                        expression: "isLoadingPdf",
                      },
                    ],
                    ref: "pdf",
                    style: _vm.setHeight,
                    on: {
                      touchmove: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-main",
                      {
                        staticClass: "pdf-content",
                        style: !_vm.isCanScroll ? { overflow: "hidden" } : {},
                      },
                      [
                        _c(
                          "el-alert",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { closable: false, type: "error" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "1.25em",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._l(_vm.showDataList, function (ref, index) {
                          var fileType = ref.fileType
                          if (fileType === void 0) fileType = ""
                          var url = ref.url
                          if (url === void 0) url = ""
                          return _c(
                            "div",
                            { key: index, staticClass: "u-m-b-20" },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.currentPosition === index,
                                      expression: "currentPosition === index",
                                    },
                                  ],
                                },
                                [
                                  fileType === "text"
                                    ? _c("div", {
                                        domProps: { innerHTML: _vm._s(url) },
                                      })
                                    : fileType === "png"
                                    ? _c("el-image", { attrs: { src: url } })
                                    : _vm.isShowPdf && fileType === "pdf"
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.currentPdfPages,
                                          function (index) {
                                            return _c("pdf", {
                                              key: index,
                                              staticStyle: {
                                                "margin-left": "160px",
                                                "margin-right": "160px",
                                              },
                                              attrs: { page: index, src: url },
                                              on: {
                                                progress: _vm.onPdfProcess,
                                                "page-loaded": _vm.onOverReload,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        _vm.isShowPdf &&
                        (_vm.currentPdfPages > 0 || _vm.currentPosition === 0)
                          ? _c("div", { staticClass: "u-m-b-20" }, [
                              _c("div", { staticClass: "customPage" }, [
                                _vm._v(
                                  _vm._s(_vm.currentPosition + 1) +
                                    "/" +
                                    _vm._s(_vm.showDataList.length)
                                ),
                              ]),
                              !_vm.isHideBtn
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: _vm.currentPosition === 0,
                                            plain: "",
                                            type: "default",
                                          },
                                          on: { click: _vm.onPageLast },
                                        },
                                        [_vm._v("上一页")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "140px" },
                                          attrs: {
                                            disabled: _vm.currentNum > 0,
                                            type: "primary",
                                          },
                                          on: { click: _vm.onPageNext },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.currentNum > 0
                                                  ? _vm.currentNum + "s后可关闭"
                                                  : "我已逐条阅读并同意"
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            !_vm.isShowPdf
              ? _c(
                  "div",
                  _vm._l(_vm.protocolInfoData.tabs, function (ref, fileIndex) {
                    var label = ref.label
                    var ref_content = ref.content
                    if (ref_content === void 0) ref_content = {}
                    var files = ref_content.files
                    if (files === void 0) files = []
                    return _c(
                      "div",
                      { key: fileIndex },
                      [
                        files.length > 0
                          ? _c(
                              "el-card",
                              {
                                staticClass: "u-m-t-20",
                                attrs: { header: label },
                              },
                              _vm._l(files, function (ref, pdfIndex) {
                                var fileType = ref.fileType
                                if (fileType === void 0) fileType = ""
                                var url = ref.url
                                if (url === void 0) url = ""
                                var name = ref.name
                                if (name === void 0) name = ""
                                return _c(
                                  "div",
                                  { key: pdfIndex, staticClass: "link" },
                                  [
                                    fileType === "pdf"
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: {
                                              href: url,
                                              target: "_blank",
                                              type: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  name.replace(".pdf", "")
                                                ) +
                                                "\n\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    fileType === "png"
                                      ? _c("el-image", { attrs: { src: url } })
                                      : _vm._e(),
                                    _c("br"),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.isHideBtn || !_vm.isShowPdf
              ? _c(
                  "el-card",
                  { staticClass: "u-m-t-20", attrs: { header: "投保人声明" } },
                  [
                    _c(
                      "el-alert",
                      {
                        staticClass: "u-m-b-10",
                        attrs: { closable: false, type: "error" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "u-font-weight-bold u-font-14" },
                          [_vm._v("为保障您的合法权益，请您仔细阅读后勾选确认")]
                        ),
                      ]
                    ),
                    _vm.clickSureData || []
                      ? _c(
                          "el-row",
                          { attrs: { justify: "start", type: "flex" } },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.checkListStatement,
                                  callback: function ($$v) {
                                    _vm.checkListStatement = $$v
                                  },
                                  expression: "checkListStatement",
                                },
                              },
                              _vm._l(
                                _vm.clickSureData,
                                function (sureItem, sureIndex) {
                                  return _c("el-checkbox", {
                                    key: sureIndex,
                                    staticClass: "u-m-b-10",
                                    attrs: { label: sureItem },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-top": "5px" },
                        attrs: { justify: "center", type: "flex" },
                      },
                      [
                        _c("el-tag", { attrs: { type: "" } }, [
                          _c(
                            "span",
                            { staticClass: "u-font-weight-bold u-font-14" },
                            [_vm._v("请滑动鼠标至底部，阅读并确认全部内容")]
                          ),
                        ]),
                        _c("p"),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { justify: "center", type: "flex" } },
                      [
                        _vm.isShowPdf
                          ? _c(
                              "el-button",
                              {
                                attrs: { plain: "", type: "primary" },
                                on: { click: _vm.onBackInsured },
                              },
                              [_vm._v("查看投保须知")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !_vm.onSureAble,
                              type: "primary",
                            },
                            on: { click: _vm.onStepConfirm },
                          },
                          [_vm._v("我已逐条阅读并同意投保")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "u-flex u-row-center u-m-t-20" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onStepConfirm } },
              [_vm._v("同意投保")]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }